import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shortName'
})
export class ShortNamePipe implements PipeTransform {
    transform(fullName: string): any {
        //if name doesn't contains @, get first and last name
        if (fullName && !fullName.includes('@')) {
            const nameArray = fullName.split(' ');
            return nameArray[0] + ' ' + nameArray[nameArray.length - 1];
        } else {
            return fullName;
        }
    }
}
